<template>
    <div class="Experience">
        <Section v-if="!$root.isDesk"/>
        <Desktop v-if="$root.isDesk"/>
    </div>
</template>

<script>

import Section from '@/components/Section.vue'
import Desktop from '@/components/Desktop.vue'

export default {
    name: 'Experience',
    components: { Section, Desktop },
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Experience
    display block
    position absolute
    top 0
    left 0
    width 100vw
    height 100%

</style>




